import { combineReducers } from 'redux';
import jwt_decode from 'jwt-decode';

const appUser = (state = null, action) => {
  switch (action.type) {
    case 'FETCH_APP_USER_FULFILLED':
      try {
        const token = action.payload.data.jwt_token;
        const decodedUser = jwt_decode(token);
        return decodedUser;
      } catch {
        console.error('invalid token format');
        return state;
      }
    case 'FETCH_APP_USER_REJECTED':
    case 'LOGOUT':
      return null;
    default:
      return state;
  }
};

const isFetching = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_APP_USER_PENDING':
      return true;
    case 'FETCH_APP_USER_REJECTED':
    case 'FETCH_APP_USER_FULFILLED':
      return false;
    default:
      return state;
  }
};

const token = (state = '', action) => {
  switch (action.type) {
    case 'REFRESH_TOKEN_FULFILLED':
      return action.payload.data.jwt_token;
    case 'LOGOUT':
      return action.payload;
    default:
      return state;
  }
};

const auth = combineReducers({
  appUser,
  isFetching,
  token,
});

export default auth;
